var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26952",
    "data-name": "Group 26952",
    transform: "translate(-164.375 -104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37724",
    "data-name": "Path 37724",
    d: "M14.375,2.375a11.922,11.922,0,0,1,8.486,3.514,12.6,12.6,0,0,1,1.759,2.227,11.723,11.723,0,0,1,1.756,6.259A12,12,0,0,1,5.889,22.861,12,12,0,0,1,14.375,2.375Zm0,22.464a10.462,10.462,0,1,0-7.4-3.064A10.4,10.4,0,0,0,14.375,24.839Z",
    transform: "translate(162 101.625)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37725",
    "data-name": "Path 37725",
    d: "M-1102.83,509.167l-3.654-3.642,1.084-1.088,2.564,2.555,6.85-6.909,1.091,1.081Z",
    transform: "translate(1277.111 -388.568)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessWhite);
export default __webpack_public_path__ + "static/media/success-white.ed44581ed062d93a7b67e3ce74b4eda3.svg";
export { ForwardRef as ReactComponent };